module.exports = __webpack_public_path__ + "img/avatar-female.cccabde1.svg";